import { render, staticRenderFns } from "./EditProductModelComponent.vue?vue&type=template&id=a6f560ec&scoped=true"
import script from "./EditProductModelComponent.vue?vue&type=script&lang=js"
export * from "./EditProductModelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f560ec",
  null
  
)

export default component.exports